import { render } from "./tax_control_panel.vue?vue&type=template&id=240055b3"
import script from "./tax_control_panel.vue?vue&type=script&lang=js"
export * from "./tax_control_panel.vue?vue&type=script&lang=js"

import exportComponent from "/root/qzf/src/kaipiao-admin-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__